import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useSelector } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import { selectors as loadMenuDataSelectors } from '../selectors/loadMenuDataSelectors'
import Avatar from '@material-ui/core/Avatar'
import CardMedia from '@material-ui/core/CardMedia'
import NumberFormat from 'react-number-format'
import { ArrowBackIos as BackButtonIcon, ArrowForwardIos as ForwardButtonIcon, } from '@material-ui/icons'
import IconButton from '@material-ui/core/IconButton'
import DigitalMenuScreen from './DigitalMenuScreen'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  avatar: {
    marginTop: '20px',
    height: 210,
    width: '100%',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  productImage: {
    marginTop: '20px',
    display: 'block',
    width: '100%',
    height: 210,
    objectFit: 'cover',
  },
  productTitle: {
    color: '#808080',
    marginTop: '30px',
    textAlign: 'center',
    textTransform: 'uppercase',
    marginLeft: '20px',
    marginRight: '20px',
  },
  productDescription: {
    color: '#888888',
    marginTop: '30px',
    textAlign: 'center',
    marginLeft: '20px',
    marginRight: '20px',
    wordWrap: 'break-word'
  },
  arrowButton: {
    marginTop: '30px'
  },
  productPrice: {
    marginTop: '20px',
    textTransform: 'uppercase',
    textAlign: 'center',
    marginLeft: '20px',
    marginRight: '20px',
  },
  productSeparator: {
    marginTop: '20px',
    border: '1px solid #F2F2F2',
  },
  productAdditionalInfo: {
    color: '#888888',
    marginTop: '30px',
    textAlign: 'center',
    marginLeft: '20px',
    marginRight: '20px',
    wordWrap: 'break-word'
  },
}))

const ProductDetails = (props) => {
  const classes = useStyles()
  const product = props.product
  const colors = useSelector(loadMenuDataSelectors.getColors)

  return (
    <DigitalMenuScreen error={!product} handleBackButtonClick={props.handleBackButtonClick} {...props}>
      <Grid container>
        <Grid item xs={12}>
          <Box
            fontSize={30}
            className={classes.productTitle}
            fontWeight="fontWeightBold"
          >
            {product?.menu?.title}
          </Box>
        </Grid>
        <Grid item xs={12}>
          {!product?.imgUrl && <Avatar variant="square" className={classes.avatar}>
            Sem imagem diponível
          </Avatar>}
          {product?.imgUrl && <CardMedia
            className={classes.productImage}
            image={product?.imgUrl}
            title={product?.title}
          />}
        </Grid>
        <Grid item xs={12}>
          <Grid container justify="center" alignContent="center" alignItems="center">
            <Grid
              item
              xs={1}
              onClick={props.handlePreviousProductClick}
            >
              {props.handlePreviousProductClick &&
              <IconButton
                className={classes.arrowButton}
              >
                <BackButtonIcon/>
              </IconButton>
              }
            </Grid>
            <Grid item xs={10}>
              <Box fontSize={24} className={classes.productDescription}>
                {product?.menu.detailedDescription || product?.menu.listDescription}
              </Box>
            </Grid>
            <Grid
              item
              xs={1}
              onClick={props.handleNextProductClick}
            >
              {props.handleNextProductClick &&
              <IconButton
                className={classes.arrowButton}
              >
                <ForwardButtonIcon/>
              </IconButton>
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Box
            fontSize={30}
            fontWeight="fontWeightBold"
            className={classes.productPrice}
            style={{ color: colors.primary }}
          >
            <NumberFormat
              value={product?.price}
              displayType={'text'}
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale={2}
              prefix={'R$'}
            />
          </Box>
        </Grid>
        {product?.menu?.additionalInfo &&
        <>
          <Grid item xs={12}>
            <hr className={classes.productSeparator}/>
          </Grid>
          <Grid item xs={12}>
            <Box fontSize={24} className={classes.productAdditionalInfo}>
              {product?.menu?.additionalInfo}
            </Box>
          </Grid>
        </>
        }
      </Grid>
    </DigitalMenuScreen>
  )
}

ProductDetails.propTypes = {
  product: PropTypes.object,
  handleBackButtonClick: PropTypes.func.isRequired,
  handlePreviousProductClick: PropTypes.func,
  handleNextProductClick: PropTypes.func,
}

export default ProductDetails
